export { default } from '../mysc/summer-camp-base'
